module.exports = __webpack_public_path__ + "img/tongdian1@2x.4b490094.png";